<div id="case-quick-processing" class="container-fluid pb-3">

    <mat-card>
        <mat-card-content *ngIf="case">

            <div class="container-fluid">
                <div class="row">

                    <div class="col-sm-4">

                        <div class="row">
                            <div class="col-sm-10">
                                <mat-form-field class="full-width">
                                    <mat-label>{{ case.trans.case_no | translate }}</mat-label>
                                    <input id="{{idPrefix}}{{case.trans.case_no}}"
                                           type="text" matInput
                                           [(ngModel)]="case.case_no"
                                           (blur)="patchCaseNumber()"
                                           [disabled]="caseNumberLocked"
                                           uppercase>
                                </mat-form-field>
                            </div>
                            <div class="col-sm-2 align-self-center">
                                <button mat-icon-button>
                                    <mat-icon id="{{idPrefix}}btn.edit_case_no" class="dr-material-icon" (click)="editCaseNumber()" aria-label="detailed">edit</mat-icon>
                                </button>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-sm-10">
                                <date-time-picker [idPrefix]="(idPrefix + case.trans.claim_date + '.')"
                                                  [date]="case.claim_date"
                                                  [time]="case.claim_date_usertime"
                                                  [options]="claimDateTimePickerOptions"
                                                  [disabled]="disabled"
                                                  (multiUpdated)="patchOpDataArray($event)">
                                </date-time-picker>
                            </div>
                            <div class="col-sm-2">
                                <!-- PLACEHOLDER FOR ACTION BUTTONS-->
                            </div>
                        </div>
                        
                        <div class="row">
                            <div class="col-sm-10">
                                <mat-form-field class="full-width">
                                    <mat-label>{{ case.trans.claim_type| translate }}</mat-label>
                                    <mat-select id="{{idPrefix}}{{case.trans.claim_type}}"
                                                [(ngModel)]="selectedClaimType"
                                                [disabled]="disabled">
                                        <mat-option *ngFor="let type of claimTypesList?.items; let idx = index"
                                                    id="{{idPrefix}}{{case.trans.claim_type}}.item_{{idx}}"
                                                    [value]="type">
                                            {{ type.displayName | translate }}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                            <div class="col-sm-2">
                                <!-- PLACEHOLDER FOR ACTION BUTTONS-->
                            </div>
                        </div>

                        <div class="row">
                                <div class="col-sm-10">
                            <mat-form-field class="full-width">
                                <mat-label>{{ case.trans.requirement | translate }}</mat-label>
                                <mat-select id="{{idPrefix}}{{case.trans.requirement}}" [(ngModel)]="selectedRequirement" [disabled]="!!disabled">
                                    <mat-option *ngFor="let type of (requirementsList$ | async); let idx = index"
                                        id="{{idPrefix}}{{case.trans.requirement}}.item_{{idx}}" [value]="type">
                                        {{ type.value }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                                </div>
                                <div class="col-sm-2">
                                </div>
                        </div>

                        <div class="row mt-2">
                            <div class="col-sm-10">
                                <div class="smp-title-small full-width">{{ caseSettingsWorkInstructions.trans | translate }}</div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-sm-10">
                                <file-operation-list *ngIf="selectedClaimType?.instructions.hasItems"
                                                     [idPrefix]="(idPrefix + 'instructions.')"
                                                     [fileMetaList]="selectedClaimType?.instructions"
                                                     [withIconAvatars]="true"
                                                     [disabledOptions]="disabledOptions"
                                                     (view)="viewFile($event)"
                                                     [disabled]="disabled">
                                </file-operation-list>

                                <div *ngIf="!selectedClaimType"
                                     class="info-message mt-3 mb-5" align="center">
                                    {{ 'detailed_processing.general.message.select_a_claim_type' | translate }}
                                </div>

                                <div *ngIf="selectedClaimType && !selectedClaimType.instructions.hasItems"
                                     class="info-message mt-3 mb-5" align="center">
                                    {{ 'detailed_processing.general.message.no_work_instructions_for_claim_type' | translate: { claimType: selectedClaimType.displayName } }}
                                </div>
                            </div>
                            <div class="col-sm-2">
                                <!-- PLACEHOLDER FOR ACTION BUTTONS-->
                            </div>
                        </div>

                        <div class="row mt-3">
                            <div class="col-sm-10">
                                <mat-form-field class="full-width">
                                    <mat-label>{{ case.trans.office | translate }}</mat-label>
                                    <mat-select id="{{idPrefix}}{{case.trans.office}}"
                                                [(ngModel)]="selectedOffice"
                                                [disabled]="disabled">
                                        <mat-option *ngFor="let office of offices; let idx = index"
                                                    id="{{idPrefix}}{{case.trans.office}}.item_{{idx}}"
                                                    [value]="office">
                                            {{ office.actionListDisplayName | translate }}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>

                            <div class="col-sm-2"></div>
                        </div>

                        <div class="row">
                            <div class="col-sm-10">
                                <mat-form-field class="full-width">
                                    <mat-label>{{ ParticipantTypes.SERVICE_CONSULTANT.trans | translate }}</mat-label>
                                    <mat-select #serviceConsultantSelect
                                                id="{{idPrefix}}{{ParticipantTypes.SERVICE_CONSULTANT.trans}}"
                                                [(ngModel)]="serviceConsultant"
                                                [disabled]="disabled">
                                        <mat-option id="{{idPrefix}}{{ParticipantTypes.SERVICE_CONSULTANT.trans}}.item_empty"></mat-option>
                                        <mat-option *ngFor="let potPart of serviceConsultantList; let idx = index"
                                                    id="{{idPrefix}}{{ParticipantTypes.SERVICE_CONSULTANT.trans}}.item_{{idx}}"
                                                    [value]="potPart">
                                            {{ potPart.displayName | translate }}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>

                            <div class="col-sm-2"></div>
                        </div>

                        <div class="row">
                            <div class="col-sm-10">
                                <mat-form-field class="full-width">
                                    <mat-label>{{ ParticipantTypes.SALES_MANAGER.trans | translate }}</mat-label>
                                    <mat-select #salesManagerSelect
                                                id="{{idPrefix}}{{ParticipantTypes.SALES_MANAGER.trans}}"
                                                [(ngModel)]="salesManager"
                                                [disabled]="disabled">
                                        <mat-option id="{{idPrefix}}{{ParticipantTypes.SALES_MANAGER.trans}}.item_empty"></mat-option>
                                        <mat-option *ngFor="let potPart of salesManagerList; let idx = index"
                                                    id="{{idPrefix}}{{ParticipantTypes.SALES_MANAGER.trans}}.item_{{idx}}"
                                                    [value]="potPart">
                                            {{ potPart.displayName | translate }}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>

                            <div class="col-sm-2"></div>
                        </div>

                        <div class="row">
                            <div class="col-sm-10">
                                <mat-form-field class="full-width">
                                    <mat-label>{{ ParticipantTypes.ASSESSOR.trans | translate }}</mat-label>
                                    <mat-select #assessorSelect
                                                id="{{idPrefix}}{{ParticipantTypes.ASSESSOR.trans}}"
                                                [(ngModel)]="assessor"
                                                [disabled]="disabled">
                                        <mat-option id="{{idPrefix}}{{ParticipantTypes.ASSESSOR.trans}}.item_empty"></mat-option>
                                        <mat-option *ngFor="let potPart of assessorList; let idx = index"
                                                    id="{{idPrefix}}{{ParticipantTypes.ASSESSOR.trans}}.item_{{idx}}"
                                                    [value]="potPart">
                                            {{ potPart.displayName | translate }}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>

                            <div class="col-sm-2"></div>
                        </div>

                        <div class="row">
                            <div class="col-sm-10">
                                <mat-form-field class="full-width">
                                    <mat-label>{{ ParticipantTypes.LAWYER.trans | translate }}</mat-label>
                                    <mat-select #lawyerSelect
                                                id="{{idPrefix}}{{ParticipantTypes.LAWYER.trans}}"
                                                [(ngModel)]="lawyer"
                                                [disabled]="disabled">
                                        <mat-option id="{{idPrefix}}{{ParticipantTypes.LAWYER.trans}}.item_empty"></mat-option>
                                        <mat-option *ngFor="let potPart of lawyerList; let idx = index"
                                                    id="{{idPrefix}}{{ParticipantTypes.LAWYER.trans}}.item_{{idx}}"
                                                    [value]="potPart">
                                            {{ potPart.displayName | translate }}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>

                            <div class="col-sm-2"> </div>
                        </div>

                    </div>

                    <div class="col-sm-4">

                        <div class="row">
                            <div class="col-sm-10">
                                <app-boolean-toggle [idPrefix]="(idPrefix + case.trans.persons_injured + '.')"
                                                    [inputLabel]="case.trans.persons_injured | translate"
                                                    [trueFalseNull]="case.persons_injured"
                                                    (trueFalseNullChange)="patchAndUpdateWithValue({ propertyName: 'persons_injured', value: $event })"
                                                    class="full-width">
                                </app-boolean-toggle>
                            </div>
                            <div class="col-sm-2">
                                <!-- PLACEHOLDER FOR ACTION BUTTONS-->
                            </div>
                        </div>

                        <quick-processing-switches [case]="case" (updated)="patchAndUpdateWithValue($event)"></quick-processing-switches>

                        <div class="row">
                            <div class="col-sm-10">
                                <app-boolean-toggle [idPrefix]="(idPrefix + case.trans.police_present + '.')"
                                                    [inputLabel]="case.trans.police_present | translate"
                                                    [trueFalseNull]="case.police_present"
                                                    (trueFalseNullChange)="patchAndUpdateWithValue({ propertyName: 'police_present', value: $event })"
                                                    class="full-width">
                                </app-boolean-toggle>
                            </div>
                            <div class="col-sm-2">
                                <!-- PLACEHOLDER FOR ACTION BUTTONS-->
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-sm-10">
                                <app-boolean-toggle [idPrefix]="(idPrefix + case.trans.compensation_requested + '.')"
                                                    [inputLabel]="case.trans.compensation_requested | translate"
                                                    [trueFalseNull]="case.compensation_requested"
                                                    (trueFalseNullChange)="patchAndUpdateWithValue({ propertyName: 'compensation_requested', value: $event })"
                                                    class="full-width">
                                </app-boolean-toggle>
                            </div>
                            <div class="col-sm-2">
                                <!-- PLACEHOLDER FOR ACTION BUTTONS-->
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-sm-10">
                                <app-boolean-toggle [idPrefix]="(idPrefix + case.trans.flatrate + '.')"
                                                    [inputLabel]="case.trans.flatrate | translate"
                                                    [trueFalseNull]="case.flatrate"
                                                    (trueFalseNullChange)="patchAndUpdateWithValue({ propertyName: 'flatrate', value: $event })"
                                                    class="full-width">
                                </app-boolean-toggle>
                            </div>
                            <div class="col-sm-2">
                                <!-- PLACEHOLDER FOR ACTION BUTTONS-->
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-sm-10">
                                <app-boolean-toggle [idPrefix]="(idPrefix + case.trans.reported_to_own_insurance + '.')"
                                                    [inputLabel]="case.trans.reported_to_own_insurance | translate"
                                                    [trueFalseNull]="case.reported_to_own_insurance"
                                                    (trueFalseNullChange)="patchAndUpdateWithValue({ propertyName: 'reported_to_own_insurance', value: $event })"
                                                    class="full-width">
                                </app-boolean-toggle>
                            </div>
                            <div class="col-sm-2">
                                <!-- PLACEHOLDER FOR ACTION BUTTONS-->
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-sm-10">
                                <app-boolean-toggle [idPrefix]="(idPrefix + case.trans.reported_to_opposing_insurance + '.')"
                                                    [inputLabel]="case.trans.reported_to_opposing_insurance | translate"
                                                    [trueFalseNull]="case.reported_to_opposing_insurance"
                                                    (trueFalseNullChange)="patchAndUpdateWithValue({ propertyName: 'reported_to_opposing_insurance', value: $event })"
                                                    class="full-width">
                                </app-boolean-toggle>
                            </div>
                            <div class="col-sm-2">
                                <!-- PLACEHOLDER FOR ACTION BUTTONS-->
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-sm-10">
                                <app-boolean-toggle [idPrefix]="(idPrefix + case.trans.perform_repair + '.')"
                                                    [inputLabel]="case.trans.perform_repair | translate"
                                                    [trueFalseNull]="case.perform_repair"
                                                    (trueFalseNullChange)="patchAndUpdateWithValue({ propertyName: 'perform_repair', value: $event })"
                                                    class="full-width">
                                </app-boolean-toggle>
                            </div>
                            <div class="col-sm-2">
                                <!-- PLACEHOLDER FOR ACTION BUTTONS-->
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-sm-10">
                                <app-boolean-toggle [idPrefix]="(idPrefix + case.trans.assessment_required + '.')"
                                                    [inputLabel]="case.trans.assessment_required | translate"
                                                    [trueFalseNull]="case.assessment_required"
                                                    (trueFalseNullChange)="patchAndUpdateWithValue({ propertyName: 'assessment_required', value: $event })"
                                                    class="full-width">
                                </app-boolean-toggle>
                            </div>
                            <div class="col-sm-2">
                                <!-- PLACEHOLDER FOR ACTION BUTTONS-->
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-sm-10">
                                <app-boolean-toggle [idPrefix]="(idPrefix + case.trans.lawyer_required + '.')"
                                                    [inputLabel]="case.trans.lawyer_required | translate"
                                                    [trueFalseNull]="case.lawyer_required"
                                                    (trueFalseNullChange)="patchAndUpdateWithValue({ propertyName: 'lawyer_required', value: $event })"
                                                    class="full-width">
                                </app-boolean-toggle>
                            </div>
                            <div class="col-sm-2">
                                <!-- PLACEHOLDER FOR ACTION BUTTONS-->
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-sm-10">
                                <app-boolean-toggle [idPrefix]="(idPrefix + case.trans.legal_protection + '.')"
                                                    [inputLabel]="case.trans.legal_protection | translate"
                                                    [trueFalseNull]="case.legal_protection"
                                                    (trueFalseNullChange)="patchAndUpdateWithValue({ propertyName: 'legal_protection', value: $event })"
                                                    class="full-width">
                                </app-boolean-toggle>
                            </div>
                            <div class="col-sm-2">
                                <!-- PLACEHOLDER FOR ACTION BUTTONS-->
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-sm-10">
                                <app-boolean-toggle [idPrefix]="(idPrefix + case.accident.trans.accident_abroad + '.')"
                                                    [inputLabel]="case.accident.trans.accident_abroad | translate"
                                                    [trueFalseNull]="case.accident.accident_abroad"
                                                    (trueFalseNullChange)="patchAndUpdateWithValue({ propertyName: 'accident.accident_abroad', value: $event })"
                                                    class="full-width">
                                </app-boolean-toggle>
                            </div>
                            <div class="col-sm-2">
                                <!-- PLACEHOLDER FOR ACTION BUTTONS-->
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-sm-10">
                                <app-boolean-toggle [idPrefix]="(idPrefix + case.trans.contributory_fault + '.')"
                                                    [inputLabel]="case.trans.contributory_fault | translate"
                                                    [trueFalseNull]="case.contributory_fault"
                                                    (trueFalseNullChange)="patchAndUpdateWithValue({ propertyName: 'contributory_fault', value: $event })"
                                                    class="full-width">
                                </app-boolean-toggle>
                            </div>
                            <div class="col-sm-2">
                                <!-- PLACEHOLDER FOR ACTION BUTTONS-->
                            </div>
                        </div>

                         <div class="row">
                            <div class="col-sm-10">
                                <app-boolean-toggle [idPrefix]="(idPrefix + case.trans.business_trip + '.')"
                                                    [inputLabel]="case.trans.business_trip | translate"
                                                    [trueFalseNull]="case.business_trip"
                                                    (trueFalseNullChange)="patchAndUpdateWithValue({ propertyName: 'business_trip', value: $event })"
                                                    class="full-width">
                                </app-boolean-toggle>
                            </div>
                            <div class="col-sm-2">
                                <!-- PLACEHOLDER FOR ACTION BUTTONS-->
                            </div>
                        </div>

                    </div>

                    <div class="col-sm-4">

                        <div class="row">
                            <div class="col-sm-10">
                                <mat-form-field class="full-width">
                                    <mat-label>{{ case.trans.comment | translate }}</mat-label>
                                    <textarea id="{{idPrefix}}{{case.trans.comment}}"
                                              matInput
                                              rows="40"
                                              [(ngModel)]="case.comment"
                                              (blur)="patchAndUpdate('comment')">
                                    </textarea>
                                </mat-form-field>
                            </div>
                        </div>
                        <div class="col-sm-2">
                            <!-- PLACEHOLDER FOR ACTION BUTTONS-->
                        </div>

                    </div>
                </div>
            </div>

        </mat-card-content>
    </mat-card>

  </div>
